<template>
    <div id="WorkflofList">
        <div id="workflow-list">
            <div style="background-color: #ffffff" class="d-flex right-page">
                <div class="ml-3 mt-3" style="flex: 0 0 100%">
                    <div class="big-title">{{ $t("task.allWorkflow") }}</div>
                    <div class="channels">
                        <div class="story channel-add" @click="createWorkflow">
                            <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                            <span class="text-large font-weight-bolder mt-2"
                                  style="font-size: 20px; letter-spacing: 2px">
                            {{ $t("task.createworkflow") }}
                        </span>
                        </div>
                        <div
                            class="channel-item"
                            v-for="(workflow, index) in getWorkflows()"
                            @click="openWorkflow(workflow._id)"
                            :key="index"
                        >
                            <div class="icon-container">
                                <WorkflowIcon />
                            </div>
                            <div class="name-container"
                            v-tippy="{ content: workflow.title, placement: 'top' }"
                            >
                                <span
                                    class="name">{{ workflow.title.length > 25 ? workflow.title.substring(0, 25) + "..." : workflow.title
                                    }}</span>
                                <span class="phone">
                            </span>
                            </div>

                            <div class="options">
                                <a-dropdown :trigger="['click']" placement="bottomRight">
                                    <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                        <span class="material-icons">more_horiz</span>
                                    </div>
                                    <template #overlay>
                                        <a-menu>
                                            <a-menu-item>
                                                <div class="icon-container" @click="editWorkFlow(workflow._id)">
                                                    <md-icon style="margin-right: 10px">edit</md-icon>
                                                    <span>{{ $t("message.edit") }}</span>
                                                </div>
                                            </a-menu-item>
                                            <a-menu-item>
                                                <div class="icon-container" @click="deleteWorkflowFunc(workflow)">
                                                    <md-icon style="margin-right: 10px">delete</md-icon>
                                                    <span>{{ $t("chatbotv2.delete") }}</span>
                                                </div>
                                            </a-menu-item>
                                        </a-menu>
                                    </template>
                                </a-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DeleteModal
                v-if="deleteModal"
                :description="$t('task.deleteWorkflow')"
                :btnCancelText="$t('message.cancel')"
                :btnoktext="$t('message.delete')"
                @cancel="deleteModal = false"
                @confirm="softDeleteWorkflow"
            />
        </div>
    </div>
</template>
<script>
import WorkflowIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WorkflowIcon.vue";
import WhatsappIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import Modal2 from "../common/Modal2.vue";
import NewMultiWhatsappChannel from "../../views/Pages/WhatsappV1/NewMultiWhatsappChannel.vue";
import AppBreadCrumb from "../common/AppBreadCrumb.vue";
import EditMultiWhatsappChannel from "../../views/Pages/WhatsappV1/UpdateDetail.vue";
import UpgradeNeeded from "../UpgradeNeeded.vue";
import Templates from "../../views/Pages/Chatbot/pages/templates/Templates.vue";
import TelegramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import SupsisIcon from "../../views/Pages/Chatbot/pages/integrations/svg/SupsisIcon.vue";
import TwitterIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TwitterIcon.vue";
import SlackIcon from "../../views/Pages/Chatbot/pages/integrations/svg/SlackIcon.vue";
import ShopifyIcon from "../fast-initialize/svg/ShopifyIcon.vue";
import FacebookIcon from "../../views/Pages/Chatbot/pages/integrations/svg/FacebookIcon.vue";
import SkypeIcon from "../../views/Pages/Chatbot/pages/integrations/svg/SkypeIcon.vue";
import WebhookIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WebhookIcon.vue";
import InstagramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import { mapActions, mapState } from "vuex";
import DeleteModal from "../../views/Pages/Tasks/components/DeleteModal.vue";

export default {
    name: "Workflow",
    components: {
        Templates,
        NewMultiWhatsappChannel,
        WhatsappIcon,
        TelegramIcon,
        SupsisIcon,
        TwitterIcon,
        SlackIcon,
        ShopifyIcon,
        FacebookIcon,
        SkypeIcon,
        WebhookIcon,
        InstagramIcon,
        Modal2,
        EditMultiWhatsappChannel,
        AppBreadCrumb,
        UpgradeNeeded,
        WorkflowIcon,
        DeleteModal,
    },
    data() {
        return {
            showCreateForm: false,
            editShowCreateForm: false,
            updatingChannel: null,
            deleteModal: false,
            maxChannelCount: 0,
            deleteChannelId: null,
            showUpgrade: false,
            deleteWorkflowId: null,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            deleteWorkflow: "tasks/deleteWorkflow",
            deleteChannel: "channel/deleteChannel",
        }),
        deleteWorkflowFunc(data) {
            this.deleteModal = true;
            this.deleteWorkflowId = data._id;
        },
        softDeleteWorkflow() {
            this.deleteWorkflow(this.deleteWorkflowId).then(() => {
                this.deleteModal = false;
            });
        },
        createWorkflow() {
            this.addNewWindow({
                type: "create-workflow",
            });
        },
        openWorkflow(id) {
            this.$emit("selected-workflow", id);
        },
        editWorkFlow(id) {
            this.$router.push(`/tasks/workflow/${id}/detail`);
        },
        getWorkflows() {
            return Object.keys(this.workflows)
                .map((workflow) => this.workflows[workflow])
                .filter((workflow) => {
                    const visibility = workflow.visibility || {};
                    const users = visibility.users || [];
                    const departments = visibility.departments || [];
                    const userSubjects = this.user.subjects || [];
                    const userId = this.user._id || null;

                    if (users.includes(userId) && departments.length === 0) {
                        return true;
                    } else if (departments.some((dept) => userSubjects.includes(dept)) && users.length === 0) {
                        return true;
                    } else if (users.includes(userId) || departments.some(dept => userSubjects.includes(dept))) {
                        return true;
                    } else if (users.length === 0 && departments.length === 0) {
                        return true;
                    }
                    return false;
                })
                .map((workflow) => {
                    return {
                        ...workflow,
                        title: workflow.title,
                    };
                });
        },
    },
};
</script>
<style lang="scss" scoped>
#WorkflofList {
    width: 100%;
    min-height: calc(100vh - 50px);
    background: var(--color-bg-default);

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &.disabled {
                opacity: 0.5;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 70px;
                height: 70px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-top: 69px;
                overflow: hidden;
                position: relative;
                background: #737981;
                padding: 10px;
            }

            .name-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                font-size: 20px;
                font-weight: bold;
                margin-top: 10px !important;
            }

            span {
                margin: 1rem 0;
                margin-top: 10px !important;
                font-weight: bold;
                display: block;
                font-size: 20px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #22272d;
            border-color: #22272d;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }
}
</style>
